import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTraktComponent } from './simple-icons-trakt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTraktComponent ],
    exports:      [ SimpleIconsTraktComponent ],
    bootstrap:    []
})
export class SimpleIconsTraktModule {}
